import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { THRESHOLD_PRESETS, Thresholds } from './types';

/** About one normal day in N lands beyond ±z spreads (two-sided normal tail). */
export function oneInDays(z: number): number {
  const t = 1 / (1 + 0.3275911 * (z / Math.SQRT2));
  const erf = 1 - (((((1.061405429 * t - 1.453152027) * t) + 1.421413741) * t - 0.284496736) * t + 0.254829592) * t * Math.exp(-(z * z) / 2);
  const tail = 1 - erf;
  return tail > 0 ? Math.round(1 / tail) : Infinity;
}

export function thresholdsEqual(a: Thresholds, b: Thresholds): boolean { return a.near === b.near && a.out === b.out; }

/** What the current edges mean, in days: how often a perfectly normal metric would still cross them. */
export function describeThresholds(t: Thresholds): string {
  return `Near edge beyond ±${t.near} spreads — about 1 normal day in ${oneInDays(t.near)} still lands there. Out of range beyond ±${t.out} — about 1 in ${oneInDays(t.out)}.`;
}

export default function ThresholdControl({ value, onChange }: { value: Thresholds; onChange: (t: Thresholds) => void }) {
  const preset = THRESHOLD_PRESETS.find(p => thresholdsEqual(p, value))?.key ?? 'custom';
  return (
    <ToggleButtonGroup size="small" exclusive value={preset} onChange={(_e, k) => { const p = THRESHOLD_PRESETS.find(x => x.key === k); if (p) onChange({ near: p.near, out: p.out }); }}
      sx={{ '& .MuiToggleButton-root': { py: 0.4, px: 1.25, fontSize: 12, textTransform: 'none', lineHeight: 1.2 } }}>
      {THRESHOLD_PRESETS.map(p => (
        <ToggleButton key={p.key} value={p.key}>
          <Tooltip title={`near ${p.near} / out ${p.out} spreads — ${p.blurb}`} arrow><span>{p.label}</span></Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
